const Icons = {
  previewIcon: require("../assets/icons/preview.png"),
  menuIcon: require("../assets/icons/menu.png"),
  helpIcon: require("../assets/icons/Help.png"),
  addIcon: require("../assets/icons/add.png"),
  exportIcon: require("../assets/icons/export.png"),
  peopleIcon: require("../assets/icons/people.png"),
  cubeIcon: require("../assets/icons/cube.png"),
  settingIcon: require("../assets/icons/setting.png"),
  dotsIcon: require("../assets/icons/dots.png"),
  profileIcon: require("../assets/icons/profile.png"),
  logoIcon: require("../assets/icons/Logo.png"),
  logoutIcon: require("../assets/icons/logout.png"),
  deleteIcon: require("../assets/icons/delete.png"),
  editIcon: require("../assets/icons/edit.png"),
  searchIcon: require("../assets/icons/search.png"),
  loginBg: require("../assets/images/loginBg.jpg"),
  loginIcon1: require("../assets/icons/login1.png"),
  loginIcon2: require("../assets/icons/login2.png"),
  loginIcon3: require("../assets/icons/login3.png"),
  loginCircle: require("../assets/icons/loginCircle.png"),
  emptyImg: require("../assets/images/emptyImg.jpg"),
  emptyPlaceholder: require("../assets/icons/placeholder.png"),

  // left side navbar icons
  dashboardIcon: require("../assets/icons/dashboard.png"),
  customerIcon: require("../assets/icons/customers.png"),
  manufacturerIcon: require("../assets/icons/manufacturer.png"),
  productIcon: require("../assets/icons/products.png"),
  orderIcon: require("../assets/icons/orders.png"),
  revenueIcon: require("../assets/icons/revenue.png"),
  transportIcon: require("../assets/icons/transport.png"),
  mastersIcon: require("../assets/icons/masters.png"),
  websiteIcon: require("../assets/icons/website.png"),

  // top navbar icons
  waveIcon: require("../assets/icons/wave.png"),
  placeholderIcon: require("../assets/icons/placeholderImg.png"),

  // dashboard top section icons
  totalGoldSaleIcon: require("../assets/icons/goldSale.png"),
  totalSliverSaleIcon: require("../assets/icons/sliverSale.png"),
  totalSalePcsRateIcon: require("../assets/icons/slack.png"),
  productSoldIcon: require("../assets/icons/productSold.png"),
  totalOrderIcon: require("../assets/icons/totalOrder.png"),
  newLoginIcon: require("../assets/icons/login.png"),
  completeOrderIcon: require("../assets/icons/completeOrder.png"),
  pendingOrderIcon: require("../assets/icons/pendingOrder.png"),
  orderPipelineIcon: require("../assets/icons/orderPipeline.png"),
  newCustomerIcon: require("../assets/icons/newCustomer.png"),
  repeatCustomerIcon: require("../assets/icons/repeatCustomer.png"),
  newSubscribeIcon: require("../assets/icons/heartSubscribe.png"),

  editIcon: require("../assets/icons/edit.png"),
  viewIcon: require("../assets/icons/view.png"),
  trashIcon: require("../assets/icons/deleteIcon.png"),
  uploadIcon: require("../assets/icons/upload.png"),

  deleteWithCircle: require("../assets/icons/deleteWithCircle.png"),
  addImageIcon: require("../assets/icons/addImage.png"),
  uploadImageIcon: require("../assets/icons/gallery-add.png"),
  logoutWithCircle: require("../assets/icons/logoutWithCircle.png"),
  uploadIcon: require("../assets/icons/upload.png"),
  emptyImg: require("../assets/images/emptyImg.jpg"),
  emptyPlaceholder: require("../assets/icons/placeholder.png"),
  // loginBgImage: require("../assets/images/ZABALI.jpg"),
  loginBgImage: require("../assets/images/loginBgImgg.jpeg"),
  loginBgImage2: require("../assets/images/loginBgImage2.png"),
  bg_login_img: require("../assets/images/bg_login_img.png"),
  bg_login_img2: require("../assets/images/bg_login_img2.jpg"),
  bg_login_img3: require("../assets/images/bg_login_img_3.png"),
  bg_login_img4: require("../assets/images/bg_login_img_4.png"),
  bg_login_img5: require("../assets/images/bg_login_img_5.jpg"),
  bg_login_img6: require("../assets/images/bg_login_img_6.jpg"),
  login_mobile_device_01: require("../assets/images/login_mobile_device_01.jpg"),
  login_mobile_device_02: require("../assets/images/login_mobile_device_02.jpg"),
  login_mobile_device_03: require("../assets/images/login_mobile_device_03.jpg"),
  login_mobile_device_04: require("../assets/images/login_mobile_device_04.jpg"),
  login_mobile_device_05: require("../assets/images/login_mobile_device_05.jpg"),
  loginBgImage3: require("../assets/images/loginBgImage3.png"),
  indiaIcon: require("../assets/images/india_icon.png"),
  cartIcon: require("../assets/images/shopping-cart_icon.png"),
  wishlistIcon: require("../assets/images/wishlist_icon.png"),
  redWishlistIcon: require("../assets/images/red_wishlist_img.png"),
  accountIcon: require("../assets/images/account_icon.png"),
  vectorDownIcon: require("../assets/images/Vector_down.png"),
  vectorUpIcon: require("../assets/images/Vector_up.png"),
  vectorRightIcon: require("../assets/images/arrow-right.png"),
  callIcon: require("../assets/images/call.png"),
  smsIcon: require("../assets/images/sms.png"),
  instagramIcon: require("../assets/images/instagram.png"),
  faceBookIcon: require("../assets/images/facebook.png"),
  whatsAppIcon: require("../assets/images/whatsapp.png"),
  downloadGooglePlayIcon: require("../assets/images/download_google_play.png"),
  downloadAppStoreIcon: require("../assets/images/download_app_store.png"),
  buildingIcon: require("../assets/images/buildings.png"),
  qrIcon: require("../assets/icons/My_QR_Code_1-1024.png"),
  androidQrIcon: require("../assets/images/android.png"),
  iosQrIcon: require("../assets/images/ios.png"),
  footerLineIcon: require("../assets/images/Line 4.png"),
  bannerImage: require("../assets/images/banner_image.png"),
  neckLaceSetImage: require("../assets/images/necklace_set.png"),
  goldRingImage: require("../assets/images/goldRing.png"),
  heartIcon: require("../assets/images/heartIcon.png"),
  paymentIcon: require("../assets/images/paymentIcon.png"),
  shieldTickIcon: require("../assets/images/shield-tick.png"),
  shippingAndDeliveryIcon: require("../assets/images/shippingAndDelivery.png"),
  SustainabilityIcon: require("../assets/images/Sustainability.png"),
  latestbrandCollectionImage: require("../assets/images/latestbrandCollection.png"),
  necklacelastecollectionImage: require("../assets/images/necklacelastecollection.png"),
  shopByColorGoldImage: require("../assets/images/shopByColorGold.png"),
  arrowCircleRightImage: require("../assets/images/arrow-circle-right.png"),
  leftSliderArrowIcon: require("../assets/images/leftSliderArrow.png"),
  rightSliderArrowIcon: require("../assets/images/rightSliderArrow.png"),
  bangleimage: require("../assets/images/bangleimage.png"),
  arrowRightSliderIcon: require("../assets/images/arrowRightSlider.png"),
  arrowLeftSliderIcon: require("../assets/images/arrowLeftSlider.png"),
  doneTickMarkIcon: require("../assets/images/done_tickMark.png"),
  addCircleIcon: require("../assets/images/add-circle.png"),
  minusCircleIcon: require("../assets/images/minus-cirlce.png"),
  activeStarIcon: require("../assets/images/active_star.png"),
  inActiveStarIcon: require("../assets/images/inActive_star.png"),
  trashIcon: require("../assets/images/trash.png"),
  backArrowIcon: require("../assets/images/back-arrow.png"),
  searchIcon: require("../assets/images/searchIcon.png"),
  emptyWishlistImage: require("../assets/images/emptyWishlistImage.png"),
  emptyCartImage: require("../assets/images/emptyCartImage.png"),
  necklaceCategoryImage: require("../assets/images/necklaceCategoryImage.png"),
  braceletCategoryImage: require("../assets/images/braceletCategoryImage.png"),
  ringsCategoryImage: require("../assets/images/ringsCategoryImage.png"),
  brandImage: require("../assets/images/brandImage.png"),
  under_review_image: require("../assets/images/under_review_image.png"),
  not_approved_image: require("../assets/images/not_approved_image.png"),
  profile_verified_image: require("../assets/images/profile_verified_image.png"),
  profile_picture_image: require("../assets/images/profile_picture_image.png"),
  manage_profile_image: require("../assets/images/manage_profile_image.png"),
  my_order_image: require("../assets/images/my_order_image.png"),
  my_address_img: require("../assets/images/my_address_img.png"),
  wallet_image: require("../assets/images/wallet_image.png"),
  reward_point_image: require("../assets/images/reward_point_image.png"),
  my_subscription_image: require("../assets/images/my_subscription_image.png"),
  share_image: require("../assets/images/share_image.png"),
  tANDc_image: require("../assets/images/t&c_image.png"),
  logout_image: require("../assets/images/logout_image.png"),
  camera_profile_image: require("../assets/images/camera_profile_image.png"),
  edit_icon: require("../assets/images/edit_icon.png"),
  green_image: require("../assets/images/green_image.png"),
  blank_image: require("../assets/images/blank_image.jpg"),
  logout_icon: require("../assets/images/logout_icon.png"),
  free_world_tour_img: require("../assets/images/free_world_tour_img.png"),
  plus_vector_icon: require("../assets/images/plus_vector.png"),
  remove_address_icon: require("../assets/images/remove_address_icon.png"),
  logout_img_icon: require("../assets/images/logout_img-icon.png"),
  default_image: require("../assets/images/default_image.jpg"),
  welcome_zabali_logo: require("../assets/images/welcome_zabali_logo.png"),
  partner1_image: require("../assets/images/partner1_image.png"),
  benefit_img: require("../assets/images/benefit-img.png"),
  minus_img: require("../assets/images/minus.png"),
  ham_menu_img: require("../assets/images/ham_menu_img.png"),
  close_ham_img: require("../assets/images/close_ham_img.png"),
  call_icon: require("../assets/images/call_icon.png"),
  whatsapp_icon: require("../assets/images/whatsapp_icon.png"),
  email_icon: require("../assets/images/email_icon.png"),
  zabali_aboutUs_img: require("../assets/images/zabali-about-us.png"),
  download_icon: require("../assets/images/download_icon.png"),
  filter_icon: require("../assets/images/filter_icon.png"),
  date_picker_icon: require("../assets/images/date_picker_icon.png"),
  refer_earn_img: require("../assets/images/refer_earn_img.png"),
  refer_earn_share_icon: require("../assets/images/refer_earn_share_icon.png"),
  cross_icon: require("../assets/images/cross_icon.png"),
  up_arrow_icon: require("../assets/images/up_arrow_icon.png"),
  down_arrow_icon: require("../assets/images/down_arrow_icon.png"),
  live_rating_image: require("../assets/images/live_rating_image.png"),

  accountSetting: require("../assets/icons/settingIcon.png"),
  ratingIcon: require("../assets/icons/rating.png"),
  moveWishlistIcon: require("../assets/icons/moveWishlist.png"),
  filterIcon: require("../assets/icons/filter-ico.png"),
  blackPlusIcon: require("../assets/icons/blackPlus.png"),
  circleCloseIcon: require("../assets/icons/circleClose.png"),
  editBlackIcon: require("../assets/icons/edit_black_icon.png"),
  logout_black_icon: require("../assets/images/logout_black_icon.png"),
  loginBgTest1: require("../assets/images/loginBgTest1.jpg"),
  loginBgTest2: require("../assets/images/loginBgTest2.jpg"),
  default_pdf_icon: require("../assets/icons/default_pdf.png"),
  logout_red_icon: require("../assets/icons/logout_red_icon.png"),
  zabali_header_logo_icon: require("../assets/icons/zabali_header_logo.png"),
  blank_star_icon: require("../assets/icons/blank_star_icon.png"),
  star_icon: require("../assets/icons/star_icon.png"),
  close_ico: require("../assets/icons/close_ico_.png"),
  live_rate_icon: require("../assets/icons/live_rate_icon.png"),
  live_rate_2: require("../assets/icons/live_rate_2.png"),
  coming_soon_img: require("../assets/images/coming_soon_img.png"),
  sequel_img: require("../assets/images/sequel.bac5d706.png"),
  free_world_tour_home_img: require("../assets/images/free_world_tour_home_img.jpg"),
  bank_building: require("../assets/images/bank-building.png"),
  bank: require("../assets/images/bank.png"),
  upi_icon: require("../assets/images/upi_icon.png"),
  rtgs_icon: require("../assets/images/rtgs_icon.png"),
  money_icon: require("../assets/images/money.png"),
  dc_logo:require("../assets/images/zabali-logo-new.png"),
  dc_banner:require("../assets/images/banner1.png"),
  dc_gallery_img_1:require("../assets/images/gallery_img_1.jpg"),
  dc_gallery_img_2:require("../assets/images/gallery_img_2.png"),
  dc_gallery_img_3:require("../assets/images/gallery_img_3.png"),
  dc_gallery_img_4:require("../assets/images/gallery_img_4.png"),
};

export default Icons;
